// Versão: 1.00
// Data..: 2026-09-29
// Miniatura de imagem que abre em POPUP (modal/lightbox) ao clicar — não em nova aba.
// Reutilizado na thread do WhatsApp e no detalhe do chamado.

import { useState } from 'react';
import { Modal } from './Modal.js';

interface ImageThumbProps {
  src: string;
  alt?: string;
  // Estilo da miniatura (tamanho máximo etc.).
  thumbStyle?: React.CSSProperties;
}

export function ImageThumb({ src, alt, thumbStyle }: ImageThumbProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <img
        src={src}
        alt={alt}
        onClick={() => setOpen(true)}
        title="Clique para ampliar"
        style={{ cursor: 'zoom-in', maxWidth: '100%', borderRadius: 8, display: 'block', ...thumbStyle }}
      />
      <Modal open={open} title={alt || 'Imagem'} onClose={() => setOpen(false)} maxWidth={960}>
        {/* Imagem ampliada, centralizada; limita a altura à viewport do modal. */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={src}
            alt={alt}
            style={{ maxWidth: '100%', maxHeight: '72vh', objectFit: 'contain', borderRadius: 8 }}
          />
        </div>
        <div className="text-center mt-3">
          <a href={src} target="_blank" rel="noreferrer" className="btn btn-sm btn-ghost">Abrir original ↗</a>
        </div>
      </Modal>
    </>
  );
}
